<template>
  <div>
    <div class="row justify-content-end align-items-end">
      <div class="col"></div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'seller-payments-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un nouveau paiement vendeur
        </button>
      </div>
    </div>
    <br />
    <vue-data-table
      :headers="headers"
      :data="sellerPayments"
      :buttons="buttons"
      :items-per-page="10"
    >
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      headers: [
        { label: "Référence", field: "reference", class: "text-center" },
        {
          label: "Référence Vente Vendeur",
          field: "seller_sale_reference",
          class: "text-left",
        },
        {
          label: "Référence Paiement",
          field: "payment_reference",
          class: "text-left",
        },
        { label: "Montant", field: "amount", class: "text-right" },
        { label: "Date", field: "date", class: "text-center" },
        {
          label: "Montant Restant",
          field: "remainingAmount",
          class: "text-right",
        },
        { label: "Remarque", field: "remark", class: "text-left" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn-info",
          action: (row) =>
            this.$router.push({
              name: "seller-payments-details",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Edit",
          icon: "bi bi-pencil",
          class: "btn-primary",
          action: (row) =>
            this.$router.push({
              name: "seller-payments-edit",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Delete",
          icon: "bi bi-trash",
          class: "btn-danger",
          action: (row) => this.remove(row.reference),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("sellerPayment", {
      sellerPayments: "getSellerPayments",
    }),
  },
  mounted() {
    this.$store.dispatch("sellerPayment/getAll");
  },
  methods: {
    async remove(reference) {
      await this.$store.dispatch("sellerPayment/destroy", reference);
    },
    async refresh() {
      await this.$store.dispatch("sellerPayment/getAll");
    },
  },
};
</script>
